/* File: src/components/explanations/shredsListExplanation.ts */
export const shredsListExplanation = `
<div class="text-gray-300 text-lg mb-4">

    <hr class="border-b-1 border-gray-600 my-2">
  
    <h2 class="text-blue-400 text-xl font-bold mb-2">1. What are Inputs/Outputs</h2>
    <p class="text-gray-200 text-base mb-4">
      In this page ShredsAI can generate for you the Inputs and Outputs of your Shred. <br/>
      Inputs are the data your Shred needs to work, Outputs are the data your Shred will return.<br>
      Example: API JSON request/response, Message Queue, etc.
    </p>
    <h2 class="text-green-400 text-xl font-bold mb-2">2. How To Generate Them ?</h2>
    <p class="text-gray-200 text-base mb-4">
      Simply hit <strong class="font-bold text-orange-200">Generate Inputs/Outputs</strong><br/>
      You also can provide them manually using the form bellow or modify the generated ones.
    </p>
    
  
</div>
`;